export const isApartment = url => {
	const regex = /^\/ibud\//;
	return regex.test(url);
};

export const isApplication = url => {
	const regex = /^\/umsokn\//;
	return regex.test(url);
};

export default function linkResolver(url) {
	if (isApplication(url)) return '/umsokn/';
	if (isApartment(url)) return '/ibud/';
	if (url[url.length - 1] !== '/') return `${url}/`;
	return url;
}
